import React from 'react';

import CommonImage from '@components/CommonImage';
import CustomDropdown from '@components/CustomDropdown';

const Header = ({ onHistoryClick }) => {
	return (
		<div className="costing-content-header">
			<div className="product-content d-flex align-items-center justify-content-between gap-2">
				<div className="d-flex align-items-start gap-2">
					{/* <button className="button text-only">
						<CommonImage src={'/icons/back-arrow-gray.svg'} alt="back" width={20} height={20} />
					</button> */}
				</div>
				<div className="brand-and-history transparent-select d-flex align-items-center gap-2">
					<div className="form-group mb-0">
						<CustomDropdown
							title="Project type*"
							onItemClick={() => {}}
							selectedItem={'Zalando'}
							items={[{ id: '1', value: 'Zalando' }]}
							isShowSearch={false}
						/>
					</div>
					<button
						className="button text-only d-flex align-items-center justify-content-center"
						onClick={onHistoryClick}
					>
						<CommonImage src="/icons/load.svg" alt="history" width={20} height={20} />
						<span className="ml-1 regular-14 gray_dark_01">History</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default Header;
